var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7268 9.50009H21.1252C21.7486 9.50009 22.2502 8.99853 22.2502 8.37509V2.37509C22.2502 1.9204 21.9783 1.5079 21.5564 1.33447C21.1346 1.16103 20.6518 1.25478 20.3283 1.57822L18.3783 3.52822C14.2721 -0.526471 7.65801 -0.512408 3.5752 3.57509C-0.526367 7.67665 -0.526367 14.3235 3.5752 18.4251C7.67676 22.5267 14.3236 22.5267 18.4252 18.4251C19.0111 17.8392 19.0111 16.8876 18.4252 16.3017C17.8393 15.7157 16.8877 15.7157 16.3018 16.3017C13.3721 19.2313 8.62363 19.2313 5.69395 16.3017C2.76426 13.372 2.76426 8.62353 5.69395 5.69384C8.60957 2.77822 13.3205 2.76415 16.2549 5.64697L14.3283 7.57822C14.0049 7.90165 13.9111 8.38447 14.0846 8.80634C14.258 9.22822 14.6705 9.50009 15.1252 9.50009H20.7268Z",
    fill: "#343435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.ced23bedaf5dfa75334b96bc6bf02280.svg";
export { ForwardRef as ReactComponent };